import * as FEEDBACK_CODES from '../constants/feedbackCodes';

// Quota
export const QUOTA_FULL_CODE = "qf";

// Question 
export const BAD_RESPONDANT_CODE = "br";
export const QUESTION_TERMINATE_CODE = "qt";
export const CONDITIONAL_LOGIC = "cl";

export const CLOSE_STUDY_CODE = "cs"; // Study no longer active
export const FILTERED_REGISTRATION_CODE = "fr"; // User does not fit study criteria, e.g. age

export const EJECT_CODE = "ej"; // Invalid user
export const SESSION_TIMEOUT = "st";

export const UNKNOWN_CODE = "un";

export const CONSENT_FORM_TERMINATION = "cf"; // NDA declined
export const WEBCAM_TERMINATION = "wc"; // User does not have or consent to webcam use
export const VIDEO_RELEASE_TERMINATION = "vr"; // User does not consent to being recorded
export const MANUAL_TERMINATION = "ml"; // User is terminated by directly modifying the database
export const AID_TERMINATION_LIST = "at";
export const QUESTION_LOGIC = "ql";

// Reasons
export const MULTI_ANSWER_TERMINATION = "mt";

export const returnScreenCodeFeedback = (screenCode) => {
	switch (screenCode) {
		case BAD_RESPONDANT_CODE: {
			return FEEDBACK_CODES.DATA_QUALITY;
		}
		case QUOTA_FULL_CODE: {
			return FEEDBACK_CODES.OVER_QUOTA;
		}
		case QUESTION_TERMINATE_CODE:
		case EJECT_CODE: {
			return FEEDBACK_CODES.TERMINATE;
		}
		default: {
			return FEEDBACK_CODES.TERMINATE;
		}
	}
};



// WEBPACK FOOTER //
// ./src/constants/screenCodes.js